const ITEMS = ["CAMPUS", "CAPABILITY", "EXPERIENCE", "PORTFOLIO", "EXPOSURE", "CAREER"];

export default function Marquee({ dark = false }) {
    const row = (
        <div className="flex shrink-0 items-center">
            {ITEMS.map((item, i) => (
                <span key={item} className="flex items-center">
                    <span
                        className={`whitespace-nowrap font-display text-4xl font-bold uppercase tracking-tight md:text-7xl ${
                            i % 2 === 0
                                ? dark
                                    ? "text-white"
                                    : "text-ink"
                                : dark
                                  ? "text-outline-sky"
                                  : "text-outline-faint"
                        }`}
                    >
                        {item}
                    </span>
                    <svg className="mx-6 h-5 w-5 shrink-0 md:mx-12 md:h-8 md:w-8" viewBox="0 0 32 32" fill="none" aria-hidden>
                        <path d="M4 16 H26 M20 8 L28 16 L20 24" stroke={dark ? "#82C8E5" : "#0047AB"} strokeWidth="1.5" />
                    </svg>
                </span>
            ))}
        </div>
    );

    return (
        <div
            className={`overflow-hidden border-y py-8 md:py-10 ${
                dark ? "border-white/10 bg-navy" : "border-ink/10 bg-white"
            }`}
            aria-hidden
        >
            <div className="marquee-track flex w-max">
                {row}
                {row}
            </div>
        </div>
    );
}
